import React, { useState } from 'react';
import { ApolloError, gql, useMutation } from '@common/hooks';
import { Modal } from 'antd';
import { mutationResponseMessage } from 'works/legacy/lib/message-helper';

const ARCHIVE_STAFFING_REQUEST_TEMPLATE_MUTATION = gql`
  mutation archiveStaffingRequestTemplateMutation($id: ID!) {
    archiveStaffingRequestTemplate(id: $id) {
      staffingRequestTemplate {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const ArchiveStaffingTemplate = ({
  staffingRequestTemplateId,
}: {
  staffingRequestTemplateId: string;
}) => {
  const [showModal, setShowModal] = useState(false);

  const [archiveStaffingRequestTemplate, { loading: mutationLoading }] =
    useMutation(ARCHIVE_STAFFING_REQUEST_TEMPLATE_MUTATION, {
      refetchQueries: ['PaginatedStaffingRequestTemplatesList'],
      variables: { id: staffingRequestTemplateId },
    });

  const handleArchiveConfirm = () => {
    if (!mutationLoading) {
      archiveStaffingRequestTemplate({
        variables: {
          id: staffingRequestTemplateId,
        },
      }).then((response) => {
        mutationResponseMessage({
          gqlResponse: response as {
            data?: unknown;
            errors?: ApolloError[] | undefined;
          },
          onSuccess: 'Staffing request template successfully archived',
          errorMessage: 'Failed to archive staffing request template',
        });

        setShowModal(false);
      });
    }
  };

  return (
    <>
      <Modal
        title={
          <b>
            Are you sure you want to archive this staffing request template?
          </b>
        }
        className="archive-staffing-request-template-modal"
        open={showModal}
        okText="Confirm"
        onCancel={() => setShowModal(false)}
        onOk={handleArchiveConfirm}
      >
        <p>After archiving, this template will not be listed.</p>
        <p>
          Note: past assignments that used this staffing request template would
          not be affected.
        </p>
      </Modal>
      <a
        className="staffing-templates-action"
        onClick={() => setShowModal(true)}
      >
        Archive
      </a>
    </>
  );
};
